import { lazy } from 'react';

export const AdminLogisticProductsPage = lazy(() => import('./AdminLogisticProductsPage'));
